export default {"src":"/_next/static/media/diagram-spotify.7050988f.svg","height":203,"width":383};